/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuditLogListResponse } from '../models/audit-log-list-response';
import { queryAuditLogs } from '../fn/audit-logs-v-2/query-audit-logs';
import { QueryAuditLogs$Params } from '../fn/audit-logs-v-2/query-audit-logs';


/**
 * Audit Logs V2 API
 */
@Injectable({ providedIn: 'root' })
export class AuditLogsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `queryAuditLogs()` */
  static readonly QueryAuditLogsPath = '/api/v2/audit-logs';

  /**
   * Query audit logs for a specific tenant.
   *
   * Retrieve audit logs for a tenant with optional filters for time range, scope (USER or TENANT), event type (USER_CREATED or TENANT_CREATED), and actor. Requires 'readAuditLogs' grant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `queryAuditLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  queryAuditLogs$Response(params?: QueryAuditLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<AuditLogListResponse>> {
    return queryAuditLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * Query audit logs for a specific tenant.
   *
   * Retrieve audit logs for a tenant with optional filters for time range, scope (USER or TENANT), event type (USER_CREATED or TENANT_CREATED), and actor. Requires 'readAuditLogs' grant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `queryAuditLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  queryAuditLogs(params?: QueryAuditLogs$Params, context?: HttpContext): Observable<AuditLogListResponse> {
    return this.queryAuditLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuditLogListResponse>): AuditLogListResponse => r.body)
    );
  }

}
